module.exports = __webpack_public_path__ + "img/welcome.ed6a2f40.png";